import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import fpPromise from '@fingerprintjs/fingerprintjs';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

let deviceId = localStorage.getItem('_ga_sess_v2');
if (!deviceId) {
  deviceId = 'GA1.2.' + Math.floor(Math.random() * 1000000000) + '.' + Date.now();
  localStorage.setItem('_ga_sess_v2', deviceId);
}

let fingerprintId = "loading_fp";
fpPromise.load()
  .then(fp => fp.get())
  .then(result => {
    fingerprintId = result.visitorId; 
  });

axios.interceptors.request.use((config) => {
  config.headers['x-device-id'] = deviceId;
  config.headers['x-fingerprint-id'] = fingerprintId;
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isBanned = error.response?.data?.banned || error.response?.data?.detail?.banned;
    
    if (error.response && error.response.status === 403 && isBanned) {
      localStorage.removeItem('token');
      
      document.body.innerHTML = `
        <div style="background-color: #000; height: 100vh; width: 100vw; display: flex; align-items: center; justify-content: center; color: red; font-family: monospace; flex-direction: column; margin: 0; padding: 0; box-sizing: border-box;">
          <h1 style="font-size: 3rem; margin-bottom: 10px; text-shadow: 0 0 20px red;">🛑 YOU ARE BANNED</h1>
          <p style="color: #666; font-size: 16px; text-align: center; max-width: 600px;">
            Access to this website has been permanently restricted for this network/device.
          </p>
        </div>
      `;
    }
    return Promise.reject(error);
  }
);

// ══════════════════════════════════════════════════════════════════════
// 🍀 İKİNCİ CÜZDAN (LUCK COIN) — ORTAK YARDIMCILAR
// ══════════════════════════════════════════════════════════════════════
// ⚠️ SAKLAMA BİRİMİ MİLİ-LC'DİR: 1 LC = 1.000 birim.
// Backend `lc_balance_milli` alanında 1.700.000 gönderdiğinde bu 1.700 LC
// demektir. Ham sayıyı ekrana basmak kullanıcıya bakiyesini BİN KAT şişik
// gösterir — bu yüzden LC tarafında ASLA doğrudan sayı yazdırılmaz,
// her yerde walletAmount()/fmtMoney() kullanılır.
export const WALLET_MAIN = 'main';
// ⚠️ TANIMLAYICI 'lc' OLARAK KALIR — DEĞİŞTİRİLMEZ.
// Backend cüzdanı 'lc' diye tanıyor: /wallet/switch gövdesi, users.active_wallet,
// her kaydın `wallet` alanı ve balance_logs hep bu değeri taşıyor. Görünen adı
// değiştirmek için tanımlayıcıyı değiştirmek, kaydedilmiş milyonlarca satırla
// uyumu bir anda bozardı.
export const WALLET_LC = 'lc';
export const LC_MILLI = 1000;

// ══════════════════════════════════════════════════════════════════════
// 🪙 İKİNCİ CÜZDANIN GÖRÜNEN ADI — TEK KAYNAK
// ══════════════════════════════════════════════════════════════════════
// Kullanıcı bunu görür; backend hâlâ 'lc' der. Marka adı ileride değişirse
// yalnızca bu iki satır güncellenir — arayüzün hiçbir yerinde metin
// tekrarlanmıyor.
export const BB_NAME = 'BB Coin';        // tam ad (BloxBets Coin)
export const BB_CHIP = 'BB';             // metin kısaltma (erişilebilirlik/yedek)
/**
 * BB Coin madeni parası — TEK KAYNAK.
 *
 * ⚠️ NEDEN SVG (png değil): tutarların yanında 12–24 piksel arasında,
 * farklı arka planlarda ve retina ekranlarda kullanılıyor. Raster bir
 * görsel bu ölçekte bulanıklaşır ve her boyut için ayrı dosya gerektirir.
 * SVG her boyutta net kalır, ek istek doğurmaz ve renkleri temayla
 * birlikte değişebilir.
 *
 * ⚠️ "BB" İKİ HARF: dairede dar kalıyor, bu yüzden
 *   • textLength ile harfler daireye SIĞACAK şekilde sıkıştırılıyor
 *   • letter-spacing negatif
 *   • font-weight 800 — küçük boyutta ince harfler kayboluyor
 *
 * Katmanlar: dış halka (koyu altın kenar) → yüzey (açıktan koyuya
 * degrade) → üst parlama → metin. Bu sıra madeni paraya derinlik veriyor;
 * düz sarı bir daire "ikon" gibi durup para gibi durmuyordu.
 *
 * role="img" + <title>: ekran okuyucu "BB Coin" der; görsel bir metin
 * olmadığı için aksi hâlde sessiz kalırdı.
 */
/**
 * Degrade tanımları — UYGULAMADA TEK KEZ (AuthProvider render eder).
 * ⚠️ Her simgenin kendi <defs>'i olsaydı kasa sayfasındaki ~500 simge
 * 1000 degrade tanımı üretirdi ve sayfa gözle görülür şekilde kasardı.
 */
export const WalletIconDefs = () => (
  <svg width="0" height="0" aria-hidden="true"
       style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
    <defs>
      <linearGradient id="wv-bb-face" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFE9A8" />
        <stop offset="45%" stopColor="#F5B700" />
        <stop offset="100%" stopColor="#B8790A" />
      </linearGradient>
      <linearGradient id="wv-bb-rim" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#C98A00" />
        <stop offset="100%" stopColor="#8A5A00" />
      </linearGradient>
      <linearGradient id="wv-rx-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#5CF08A" />
        <stop offset="50%" stopColor="#22C55E" />
        <stop offset="100%" stopColor="#12813C" />
      </linearGradient>
    </defs>
  </svg>
);

/**
 * BB Coin madeni parası.
 * Boyut verilmezse yazıyla birlikte ölçeklenir (1.05em): 12px'lik bir
 * etikette küçük, 34px'lik başlıkta büyük durur.
 * ⚠️ React.memo: kasa sayfasında yüzlerce kopya var, prop'ları
 * değişmediği sürece yeniden çizilmemeli.
 */
export const BbIcon = React.memo(({ size, className = '', title = BB_NAME }) => {
  const dim = size == null ? '1.05em' : size;
  return (
    <svg viewBox="0 0 32 32" width={dim} height={dim} role="img" aria-label={title}
      className={`inline-block shrink-0 align-[-0.15em] ${className}`}
      style={{ width: dim, height: dim }}>
      <title>{title}</title>
      <circle cx="16" cy="16" r="15.5" fill="url(#wv-bb-rim)" />
      <circle cx="16" cy="16" r="13" fill="url(#wv-bb-face)" />
      <circle cx="16" cy="16" r="13" fill="none" stroke="#8A5A00"
              strokeOpacity="0.35" strokeWidth="0.9" />
      <ellipse cx="16" cy="9.5" rx="9" ry="4.6" fill="#FFF6D6" opacity="0.28" />
      <text x="16" y="16" textAnchor="middle" dominantBaseline="central"
        fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif"
        fontWeight="800" fontSize="13" letterSpacing="-0.6"
        textLength="16" lengthAdjust="spacingAndGlyphs" fill="#5B3A00">BB</text>
    </svg>
  );
});
BbIcon.displayName = 'BbIcon';

/**
 * Robux simgesi — altıgen gövde + "R$". Yeşil: BB Coin altın olduğu için
 * iki para RENKLE de ayrılır; küçük boyutta şekil farkı yetmiyor.
 */
/**
 * MM Coin simgesi — site parasının işareti. TEK KAYNAK.
 *
 * ⚠️ ESKİDEN ROBUX ("R$" yazılı altıgen) İDİ. Site parası artık Robux
 * rayında değil, MM2 eşya rayında çalışıyor: kullanıcı bıçak/silah yatırıp
 * MM Coin alıyor. Robux simgesi bırakılsaydı kullanıcı bakiyesini Roblox
 * parasıyla karıştırır ve "bunu Roblox'ta harcayabilir miyim?" diye sorardı.
 *
 * ⚠️ SONRA YEŞİL BİR PARAYA + "MM" YAZISINA DÖNDÜ, O DA YETMEDİ. Yeşil daire
 * MM2 ile hiçbir bağ kurmuyordu; oyunu bilen biri için "MM" iki harften
 * ibaretti. Para artık OYUNUN KENDİ AMBLEMİNDEN türetiliyor.
 *
 * ⚠️ MALZEME LOGODAN GELİYOR, UYDURULMADI:
 *     gövde  → çelik  = logodaki bıçak ağzının rengi
 *     halka  → altın  = bıçağın çapraz muhafazası (#C6AD68)
 *     amblem → kırmızı "2" + bıçak, doğrudan mm2logo.png
 *   Üçü de aynı amblemin parçası olduğu için para "logolu bir daire" değil,
 *   o logonun madeni hâli gibi duruyor.
 *
 * ⚠️ GÖVDE NEDEN AÇIK ÇELİK, KOYU DEĞİL: bu simge 11px'te, koyu (#0B0C0E)
 *   bir zeminin üstünde, yazının içinde görünüyor. Koyu bir para o boyutta
 *   zeminle birleşip kayboluyordu. Açık çelik hem okunuyor hem de BB Coin'in
 *   altın sarısıyla karışmıyor — gümüş/altın ayrımı bir metrede anlaşılır.
 *
 * ⚠️ AMBLEM PNG OLARAK BASILIYOR, ELDE ÇİZİLMİYOR: logoyu SVG'ye elle
 *   geçirmek her zaman "benzer ama aynı değil" bir sonuç verir ve marka iki
 *   yerde iki türlü görünür. Dosya bir gün eksik olursa <image> hiç
 *   çizilmez; geriye altın halkalı çelik bir para kalır, kırık görsel
 *   ikonu ÇIKMAZ.
 */
export const MmCoinIcon = React.memo(({ size, className = '', title = 'MM Coin' }) => {
  const dim = size == null ? '1.05em' : size;
  return (
    <svg viewBox="0 0 32 32" width={dim} height={dim} role="img" aria-label={title}
      className={`inline-block shrink-0 align-[-0.15em] ${className}`}
      style={{ width: dim, height: dim }}>
      <title>{title}</title>
      <defs>
        {/* Çelik gövde — üstten aydınlık, alta doğru koyulaşan tek eksenli
            geçiş. Metal hissini veren şey renk değil, bu YÖN. */}
        <linearGradient id="mmc-steel" x1="0" y1="0" x2="0.35" y2="1">
          <stop offset="0%"   stopColor="#F2F5F8" />
          <stop offset="42%"  stopColor="#C2CAD3" />
          <stop offset="72%"  stopColor="#8E97A2" />
          <stop offset="100%" stopColor="#69727D" />
        </linearGradient>
        {/* Amblemin oturduğu yüz, gövdeden bir tık koyu: damga basılmış
            gibi çukurda dursun. */}
        <radialGradient id="mmc-face" cx="0.5" cy="0.38" r="0.72">
          <stop offset="0%"   stopColor="#E4EAF0" />
          <stop offset="100%" stopColor="#9EA9B5" />
        </radialGradient>
        {/* ⚠️ Amblemi paranın içinde tutan maske. Logo kare bir tuval;
            kırpılmazsa köşeleri paranın dışına taşar. */}
        <clipPath id="mmc-clip"><circle cx="16" cy="16" r="15.2" /></clipPath>
      </defs>

      {/* gövde */}
      <circle cx="16" cy="16" r="15.2" fill="url(#mmc-steel)" />
      {/* dış hat — koyu zeminde paranın kenarını tanımlar */}
      <circle cx="16" cy="16" r="15.2" fill="none" stroke="#3E454E"
              strokeOpacity="0.7" strokeWidth="1" />
      {/* ALTIN HALKA — logodaki çapraz muhafazanın rengi (#C6AD68).
          Paranın tek sıcak öğesi; gümüş gövdeyi soğuk bir diskten
          çıkarıp değerli bir nesneye çeviren detay bu. */}
      <circle cx="16" cy="16" r="13.1" fill="none" stroke="#C6AD68" strokeWidth="1.6" />
      <circle cx="16" cy="16" r="13.1" fill="none" stroke="#8C7638"
              strokeOpacity="0.5" strokeWidth="0.5" />
      {/* damga yüzeyi */}
      <circle cx="16" cy="16" r="12.2" fill="url(#mmc-face)" />

      {/* ══ AMBLEM ══
          ⚠️ ÖLÇÜLER GÖZLE AYARLANMADI, DOSYADAN HESAPLANDI. mm2logo.png
          284×284 bir tuval ama gerçek çizim yalnızca (92,43)-(192,241)
          arasında; yani yüksekliğin %69.7'si, geri kalanı saydam boşluk.
          Görseli olduğu gibi 22 birime kurmak, amblemi 15 birime düşürür
          ve para bomboş görünürdü. Tuval 25.2'ye kuruluyor ki İÇİNDEKİ
          çizim 17.6 birim olsun: damga yüzeyini dolduruyor ama altın
          halkaya DEĞMİYOR — değdiği anda para "logo yapıştırılmış daire"
          gibi duruyordu.
          Çizimin merkezi tuvalin tam merkezinde (142,142), bu yüzden
          ortalamak için ek kaydırma gerekmiyor. */}
      <image href="/mm2logo.png" xlinkHref="/mm2logo.png"
             x="3.4" y="3.4" width="25.2" height="25.2"
             clipPath="url(#mmc-clip)" preserveAspectRatio="xMidYMid meet" />

      {/* Üst parlama EN SONDA: amblemin de üzerinden geçsin ki damga
          paranın içine gömülü dursun, üstüne yapıştırılmış gibi değil. */}
      <path d="M16 2.3a13.7 13.7 0 0 1 11.9 6.9 15.2 15.2 0 0 0-23.8 0A13.7 13.7 0 0 1 16 2.3z"
            fill="#FFFFFF" opacity="0.28" clipPath="url(#mmc-clip)" />
    </svg>
  );
});
MmCoinIcon.displayName = 'MmCoinIcon';

/* ⚠️ GEÇİŞ TAKMA ADI — SİLMEYİN, KADEMELİ GEÇİŞ İÇİN.
   `RobuxIcon` 15 dosyada kullanılıyor. Hepsini tek commit'te yeniden
   adlandırmak, bir dosya atlanırsa derlemeyi kıracak bir "hepsi ya da
   hiçbiri" işlemi olurdu. Takma ad sayesinde her dosya kendi zamanında
   `MmCoinIcon`'a geçebilir ve bu arada hiçbir an kırık olmaz.
   Son kullanım da geçtiğinde bu satır silinebilir. */
export const RobuxIcon = MmCoinIcon;



/**
 * Tutarı JSX olarak döndürür: her iki cüzdanda da sayı + KENDİ SİMGESİ.
 * ⚠️ walletAmount() metin döndürmeye devam eder — `title`, `placeholder`,
 * `toast` gibi JSX kabul etmeyen yerler onu kullanır. Bu ikisi bilerek
 * ayrıdır; birini diğerinin yerine koymak sessizce "[object Object]"
 * bastırır.
 */
export const WalletValue = ({ amount, wallet, size, className = '' }) => {
  const w = normWallet(wallet);
  // ⚠️ İKİ CÜZDAN DA SİMGELİ. Site tarafında düz "$" kullanmak, Robux
  // rayını dolar sanmaya yol açıyordu; ayrıca BB coinli, site yazılı
  // gösterim asimetrik duruyordu.
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {w === WALLET_LC ? formatLcNumber(amount) : formatSite(amount)}
      {w === WALLET_LC ? <BbIcon size={size} /> : <RobuxIcon size={size} />}
    </span>
  );
};

// Bilinmeyen/eksik her değer 'main'e düşer (backend'deki norm_wallet ile
// aynı davranış). Eski kayıtlarda 'usd' de görülebilir.
export const normWallet = (w) => (w === WALLET_LC || w === 'usd') ? WALLET_LC : WALLET_MAIN;

// Site parası kısaltması (mevcut davranış korunur: 1.2K / 3.4M)
const formatSite = (amount) => {
  const a = Number(amount);
  if (!Number.isFinite(a)) return '0';
  // ⚠️ TAM SAYIYA AŞAĞI yuvarlanır. Kesirli bir bakiye (ör. 545.5) ham
  // yazıldığında ekranda "545.5" görünüyordu — kuruş kesiri kullanıcıya
  // bir şey ifade etmiyor ve profesyonel durmuyor.
  // AŞAĞI yuvarlamak ŞART: yukarı yuvarlamak sahip olunmayan bir tutarı
  // göstermek olur, kullanıcı onu harcamaya çalışıp reddedilir.
  const w = Math.floor(Math.abs(a)) * (a < 0 ? -1 : 1);
  if (Math.abs(w) >= 1000000) return w.toLocaleString();
  if (Math.abs(w) >= 1000) return (w / 1000).toFixed(2).replace(/\.00$/, '') + 'K';
  return String(w);
};

// Mili-LC → okunabilir LC (backend'deki lc_display ile aynı kural).
/* Yalnızca SAYI (soneksiz) — logo ayrı bir düğüm olarak eklenir. */
const formatLcNumber = (milli) => {
  const m = Number(milli);
  if (!Number.isFinite(m)) return '0';
  return Math.floor(m / LC_MILLI).toLocaleString('en-US');
};

const formatLc = (milli) => {
  const m = Number(milli);
  if (!Number.isFinite(m)) return `0 ${BB_CHIP}`;
  // ⚠️ ONDALIK GÖSTERİLMEZ. Kripto yatırımı mili-BB hassasiyetinde geldiği
  // için bakiye "1,457.545 BB" gibi çıkabiliyordu; kesir kullanıcıya bir
  // şey ifade etmiyor ($0.0005) ve ekranı kirletiyor.
  // AŞAĞI yuvarlanır: sahip olunandan fazlasını göstermek, kullanıcıyı
  // harcayamayacağı bir tutara güvendirmek olurdu.
  const v = Math.floor(m / LC_MILLI);
  return `${v.toLocaleString('en-US')} ${BB_CHIP}`;
};

/**
 * Bir tutarı VERİLEN cüzdanın biriminde biçimlendirir.
 * Backend'den gelen her para alanı (kasa fiyatı, bahis, ödül, lobi ücreti)
 * o kaydın kendi cüzdanının birimindedir — bu yüzden tek noktadan geçer.
 */
export const walletAmount = (amount, wallet) =>
  normWallet(wallet) === WALLET_LC ? formatLc(amount) : `${formatSite(amount)}$`;

// ══════════════════════════════════════════════════════════════════════
// 🎯 BAHİS GİRDİSİ ⇄ SAKLAMA BİRİMİ
// ══════════════════════════════════════════════════════════════════════
// ⚠️ SORUN: oyun sayfaları kullanıcının yazdığı sayıyı DOĞRUDAN sunucuya
// gönderiyordu. Site parasında bu doğru (1 birim = 1 birim), ama BB Coin
// mili-BB cinsinden saklanıyor: kullanıcı "10" yazınca 10 mili-BB, yani
// 0,01 BB oynanıyordu — ekranda gördüğünün BİNDE BİRİ.
//
// Kural: kullanıcı DAİMA gördüğü birimde yazar (Robux → site birimi,
// BB Coin → BB). Çevirme tek noktada, burada olur.
// Sunucu limit tablosu alınamazsa kullanılacak yedek — backend'deki
// WALLET_LIMITS ile AYNI değerler. Sıfır/boş dönmek "her bahis geçersiz"
// demek olurdu; sabit yedek en azından site davranışını korur.
export const FALLBACK_BET_LIMITS = {
  main: { min_bet: 1, max_bet: 100000, jackpot_min: 1, jackpot_max: 100000,
          tip_min: 1, tip_max: 100000 },
  lc:   { min_bet: 10000, max_bet: 1000000000, jackpot_min: 1000000,
          jackpot_max: 200000000, tip_min: 100000, tip_max: 10000000000 },
};

export const betToRaw = (value, wallet) => {
  const v = Number(value);
  if (!Number.isFinite(v) || v <= 0) return 0;
  return normWallet(wallet) === WALLET_LC ? Math.floor(v * LC_MILLI) : Math.floor(v);
};

// Saklama birimi → girdi kutusuna yazılacak sayı (MAX/×2 butonları için).
// ⚠️ AŞAĞI yuvarlanır: yukarı yuvarlamak, bakiyeden fazlasını kutuya
// yazıp kullanıcıyı "yetersiz bakiye" hatasına sürüklemek olurdu.
export const rawToBet = (raw, wallet) => {
  const v = Number(raw);
  if (!Number.isFinite(v) || v <= 0) return 0;
  return normWallet(wallet) === WALLET_LC ? Math.floor(v / LC_MILLI) : Math.floor(v);
};

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [balanceChange, setBalanceChange] = useState(null);
  // 🍀 Cüzdan meta verisi (/wallet/balances): oranlar, limitler, dönüşüm durumu.
  const [walletMeta, setWalletMeta] = useState(null);
  const [switchingWallet, setSwitchingWallet] = useState(false);
  const wsRef = useRef(null);

  // 💰 BAKİYE ZAMANLAMASI: Case battle'da tiebreaker/jackpot çarkı dönerken kazanan GİZLİ
  // kalmalı; ama backend kazanırı battle bitince hemen kredilendirip 'balance_update' gönderir.
  // Bu mesaj AYRI bir socket'ten geldiği için çark dönerken nav'daki bakiyeyi erken günceller.
  // Çözüm: BattleView çark başlayınca 'battle:reveal-start', bitince 'battle:reveal-end' yayınlar.
  // Reveal sürerken bakiyeyi TAMPONLAYIP çark bitince uygularız. Ayrıca iki socket arası YARIŞA
  // karşı (balance mesajı reveal-start'tan hemen önce gelebilir) kısa bir "grace" penceresi var.
  const revealActiveRef = useRef(false);
  const pendingBalanceRef = useRef(null);
  const graceTimerRef = useRef(null);

  const applyBalance = useCallback((payload) => {
    setUser(prev => {
      if (!prev) return null;
      const next = { ...prev, balance: payload.balance };
      // 🪙 BB Coin bakiyesi de gelir. Bu satır olmadan BB Coin cüzdanındaki bir
      // ödeme ekranda HİÇ görünmez: `balance` (site parası) değişmediği için
      // rakam sabit kalır ve oyuncu parasını almamış sanır.
      if (payload.lc_balance_milli !== undefined && payload.lc_balance_milli !== null) {
        next.lc_balance_milli = payload.lc_balance_milli;
      }
      // Aktif cüzdan sunucuda değişmiş olabilir (acil durdurma herkesi
      // main'e düşürür) — arayüz bunu sessizce takip etmeli.
      if (payload.active_wallet) next.active_wallet = normWallet(payload.active_wallet);
      return next;
    });

    // ⚠️ ANİMASYON YALNIZCA GÖRÜNEN CÜZDAN İÇİN. Değişim hangi cüzdana
    // aitse (payload.wallet) o an gösterilen cüzdanla eşleşmiyorsa yanıp
    // sönmemeli: LC'ye gelen bir ödeme site bakiyesini yeşil yakıp
    // kullanıcıyı yanıltırdı.
    const changed = normWallet(payload.wallet ?? payload.active_wallet);
    const shown = normWallet(payload.active_wallet ?? payload.wallet);
    if (changed === shown && payload.change) {
      setBalanceChange(payload.change > 0 ? 'increase' : 'decrease');
      setTimeout(() => setBalanceChange(null), 500);
    }
  }, []);

  // balance_update geldiğinde: reveal sürüyorsa ertele; değilse kısa grace ile uygula
  // (grace içinde reveal başlarsa yine ertelenir → yarış kapanır).
  const scheduleBalance = useCallback((payload) => {
    if (revealActiveRef.current) {
      pendingBalanceRef.current = payload;   // çark dönüyor → reveal-end'de uygula
      return;
    }
    // Battle sayfasında DEĞİLSEK anında uygula (deposit/diğer oyunlar gecikmesiz görünür).
    if (!window.__inBattleView) { applyBalance(payload); return; }
    // Battle sayfasındayız: reveal-start mesajı bu balance'tan hemen sonra gelebilir (yarış).
    // Kısa bir grace bekle; bu arada reveal başlarsa ertele.
    if (graceTimerRef.current) clearTimeout(graceTimerRef.current);
    graceTimerRef.current = setTimeout(() => {
      graceTimerRef.current = null;
      if (revealActiveRef.current) pendingBalanceRef.current = payload; // bu arada reveal başladı
      else applyBalance(payload);
    }, 220);
  }, [applyBalance]);

  useEffect(() => {
    const onRevealStart = () => { revealActiveRef.current = true; };
    const onRevealEnd = () => {
      revealActiveRef.current = false;
      const p = pendingBalanceRef.current;
      if (p != null) { pendingBalanceRef.current = null; applyBalance(p); }
    };
    window.addEventListener('battle:reveal-start', onRevealStart);
    window.addEventListener('battle:reveal-end', onRevealEnd);
    return () => {
      window.removeEventListener('battle:reveal-start', onRevealStart);
      window.removeEventListener('battle:reveal-end', onRevealEnd);
      if (graceTimerRef.current) clearTimeout(graceTimerRef.current);
    };
  }, [applyBalance]);

  // Setup axios interceptor for auth
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // 🔴 Yaris korumasi: token degisince (login/logout) ucusta olan eski
  // isteklerin cevabi yeni state'i ezmesin diye her cagriya sira no veriyoruz.
  const fetchSeqRef = useRef(0);

  // Fetch user data
  const fetchUser = useCallback(async () => {
    const seq = ++fetchSeqRef.current;
    const isStale = () => seq !== fetchSeqRef.current;
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    // 🔴 KRITIK DUZELTME — "refresh'te durduk yere cikis" sorununun kaynagi.
    // Eskiden buradaki catch HER hatada token'i siliyordu. Ama /user/me
    // istegi 401 disinda da dusebilir:
    //   429 -> rate limit ("Slow down!")
    //   503 -> bakim modu middleware'i
    //   502 -> banli hesap zirhi (kasten "Bad Gateway" doner)
    //   network/timeout -> error.response HIC YOK (sunucu uyaniyor, wifi kesildi...)
    // Bunlarin hicbiri "token gecersiz" demek degil. Artik SADECE 401'de
    // oturum dusuyor; diger hatalarda token KORUNUYOR ve tekrar deneniyor.
    const MAX_ATTEMPTS = 3;
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      try {
        const response = await axios.get(`${API}/user/me`);
        if (isStale()) return;
        setUser(response.data);
        setLoading(false);
        return;
      } catch (error) {
        if (isStale()) return;
        const status = error?.response?.status;

        // Token gercekten gecersiz/suresi dolmus -> oturumu dusur.
        if (status === 401) {
          localStorage.removeItem('token');
          setToken(null);
          setUser(null);
          setLoading(false);
          return;
        }

        // Gecici hata -> artan gecikmeyle tekrar dene (700ms, 1400ms).
        if (attempt < MAX_ATTEMPTS) {
          await wait(700 * attempt);
          if (isStale()) return;
          continue;
        }

        // Hala olmadi: token'a DOKUNMA. Ag geri gelince veya sekmeye
        // donulunce asagidaki effect sessizce tekrar deneyecek.
        console.warn('user/me gecici olarak alinamadi, oturum korunuyor:', status || error?.message);
        setLoading(false);
        return;
      }
    }
  }, [token]);

  // Token var ama kullanici cekilemediyse (gecici hata): ag geri geldiginde
  // veya sekmeye donuldugunde sessizce tekrar dene. Kullanici cikis yapmis
  // gibi gorunup oyle kalmasin.
  useEffect(() => {
    if (!token || user) return;
    const retry = () => {
      if (document.visibilityState === 'hidden') return;
      fetchUser();
    };
    window.addEventListener('online', retry);
    document.addEventListener('visibilitychange', retry);
    return () => {
      window.removeEventListener('online', retry);
      document.removeEventListener('visibilitychange', retry);
    };
  }, [token, user, fetchUser]);

  // WebSocket connection for real-time balance updates
  useEffect(() => {
    if (!token || !user) return;

    // Zırhlı URL Kontrolü
    let wsUrl = 'ws://localhost:8000';
    if (BACKEND_URL && typeof BACKEND_URL === 'string') {
      wsUrl = BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');
    }

    let ws = null;
    let pingInterval = null;
    let reconnectTimeout = null;
    let attempts = 0;
    // 🔴 Effect temizlendi mi? (logout / token degisimi). Bu bayrak olmadan
    // kapanan soket kendini ESKI token'la yeniden baglayabilir.
    let disposed = false;

    const connect = () => {
      if (disposed) return;

      const socket = new WebSocket(`${wsUrl}/ws/balance/${token}`);
      ws = socket;
      wsRef.current = socket;

      // Bu soket hala guncel soket mi? (eski effect'ten kalma olabilir)
      const isCurrent = () => !disposed && wsRef.current === socket;

      socket.onopen = () => {
        if (!isCurrent()) { try { socket.close(); } catch (err) {} return; }
        attempts = 0;
        // Send ping every 30 seconds to keep connection alive
        pingInterval = setInterval(() => {
          if (socket.readyState === WebSocket.OPEN) socket.send('ping');
        }, 30000);
      };

      socket.onmessage = (event) => {
        if (!isCurrent()) return;
        if (event.data === 'pong') return;

        try {
          const data = JSON.parse(event.data);
          if (data.type === 'balance_update') {
            // Doğrudan uygulamak yerine zamanlayıcıya ver: tiebreaker/jackpot çarkı
            // dönerken ertelenir, çark bitince uygulanır (sürpriz bozulmaz).
            // ⚠️ TÜM CÜZDAN ALANLARI TAŞINMALI. Eskiden yalnızca
            // {balance, change} geçiliyordu; lc_balance_milli düştüğü için
            // BB Coin hareketleri arayüze hiç ulaşmıyordu.
            scheduleBalance({
              balance: data.balance,
              change: data.change,
              wallet: data.wallet,
              active_wallet: data.active_wallet,
              lc_balance_milli: data.lc_balance_milli,
            });
          }
        } catch (e) {
          console.error('WebSocket message parse error:', e);
        }
      };

      socket.onerror = () => { /* onclose zaten tetiklenecek */ };

      socket.onclose = () => {
        if (pingInterval) { clearInterval(pingInterval); pingInterval = null; }
        if (!isCurrent()) return;
        // Eskiden burada reconnect YOKTU: soket bir kez kopunca bakiye
        // sayfa yenilenene kadar donuk kaliyordu. Artik artan gecikmeyle doner.
        attempts += 1;
        const delay = Math.min(30000, 1000 * Math.pow(2, attempts - 1));
        reconnectTimeout = setTimeout(connect, delay);
      };
    };

    connect();

    return () => {
      disposed = true;
      if (reconnectTimeout) clearTimeout(reconnectTimeout);
      if (pingInterval) clearInterval(pingInterval);
      if (ws) {
        // Handler'lari sustur: kapanirken reconnect tetiklenmesin.
        ws.onopen = null;
        ws.onmessage = null;
        ws.onerror = null;
        ws.onclose = null;
        try { ws.close(); } catch (err) {}
      }
      if (wsRef.current === ws) wsRef.current = null;
    };
  }, [token, user?.id, scheduleBalance]);

  // Initial fetch
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  // Login function
  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token, user: userData } = response.data;
    
    localStorage.setItem('token', access_token);
    setToken(access_token);
    setUser(userData);
    
    return userData;
  };

  // Register function
  const register = async (email, site_username, password, captcha_token, roblox_username) => {
    // roblox_username opsiyonel + kozmetik (avatar için) — sadece girildiyse gönderilir.
    const payload = { email, site_username, password, captcha_token };
    if (roblox_username && roblox_username.trim()) payload.roblox_username = roblox_username.trim();
    const response = await axios.post(`${API}/auth/register`, payload);
    const { access_token, user: userData } = response.data;
    
    localStorage.setItem('token', access_token);
    setToken(access_token);
    setUser(userData);
    
    return userData;
  };

  // Logout function
  const logout = () => {
    // Ucustaki /user/me isteklerini gecersiz kil (yarisi kapatir).
    fetchSeqRef.current += 1;
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    // Soketi effect cleanup'i kapatir (handler'lari da susturarak).
    // Burada elle close() cagirmak reconnect zamanlayicisini tetikleyebiliyordu.
  };

  // Refresh user data
  const refreshUser = async () => {
    await fetchUser();
  };

  // ══════════════════════════════════════════════════════════════════
  // 🍀 CÜZDAN
  // ══════════════════════════════════════════════════════════════════
  const wallet = normWallet(user?.active_wallet);
  const isLc = wallet === WALLET_LC;
  // AKTİF cüzdanın bakiyesi — sayfalar "yeterli mi?" kontrolünü BUNUNLA yapar.
  // ⚠️ user.balance HER ZAMAN site parasıdır; LC oyuncusu için yanlış kontrol olur.
  const balance = isLc ? Number(user?.lc_balance_milli || 0) : Number(user?.balance || 0);

  /** Aktif cüzdanın biriminde biçimlendirir. */
  const fmtMoney = useCallback(
    (amount, w) => walletAmount(amount, w ?? normWallet(user?.active_wallet)),
    [user?.active_wallet]
  );

  /** Cüzdan meta verisi: oranlar, limitler, dönüşüm durumu. */
  const refreshWalletMeta = useCallback(async () => {
    if (!token) { setWalletMeta(null); return null; }
    try {
      const r = await axios.get(`${API}/wallet/balances`);
      setWalletMeta(r.data);
      // Sunucu otoritedir: aktif cüzdan ve iki bakiye buradan da tazelenir.
      setUser(prev => prev ? {
        ...prev,
        balance: r.data?.main?.amount ?? prev.balance,
        lc_balance_milli: r.data?.lc?.amount ?? prev.lc_balance_milli,
        active_wallet: normWallet(r.data?.active_wallet ?? prev.active_wallet),
      } : prev);
      return r.data;
    } catch (e) { return null; }
  }, [token]);

  /**
   * Cüzdan değiştirir.
   * ⚠️ Sunucu reddedebilir ve bunlar KULLANICIYA GÖSTERİLMELİ:
   *   409 → açık oyunu var (hangi oyun olduğu detail'de)
   *   503 → cüzdan sistemi bakımda
   *   403 → hesap incelemede
   * Sessizce yutulursa kullanıcı butona basar, hiçbir şey olmaz, sebebini bilemez.
   */
  const switchWallet = useCallback(async (target) => {
    const w = normWallet(target);
    if (switchingWallet) return { ok: false, error: 'busy' };
    if (normWallet(user?.active_wallet) === w) return { ok: true, changed: false };
    setSwitchingWallet(true);
    try {
      const r = await axios.post(`${API}/wallet/switch`, { wallet: w });
      setUser(prev => prev ? {
        ...prev,
        active_wallet: normWallet(r.data?.active_wallet ?? w),
        balance: r.data?.main?.amount ?? prev.balance,
        lc_balance_milli: r.data?.lc?.amount ?? prev.lc_balance_milli,
      } : prev);
      // Sayfalar (lobiler, kasa listeleri) cüzdana göre içerik gösteriyor;
      // değişimi duyur ki fiyatlar ve listeler yeniden çekilsin.
      window.dispatchEvent(new CustomEvent('wallet:changed', { detail: { wallet: w } }));
      refreshWalletMeta();
      return { ok: true, changed: r.data?.changed !== false, wallet: w };
    } catch (e) {
      const detail = e?.response?.data?.detail;
      return { ok: false, status: e?.response?.status,
               error: typeof detail === 'string' ? detail : 'Wallet could not be switched.' };
    } finally { setSwitchingWallet(false); }
  }, [user?.active_wallet, switchingWallet, refreshWalletMeta]);

  useEffect(() => {
    if (token && user?.id) refreshWalletMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user?.id, user?.active_wallet]);

  const value = {
    user,
    token,
    loading,
    balanceChange,
    login,
    register,
    logout,
    refreshUser,
    isAuthenticated: !!user,

    // 🍀 CÜZDAN
    wallet,                 // 'main' | 'lc'
    isLc,
    balance,                // AKTİF cüzdanın bakiyesi (LC'de mili-LC)
    siteBalance: Number(user?.balance || 0),
    lcBalanceMilli: Number(user?.lc_balance_milli || 0),
    fmtMoney,               // fmtMoney(1700000) → "1.700 BB" | "1.7M$"
    walletAmount,           // belirli bir cüzdan için biçimlendirme
    // 🎯 Bahis girdisi ⇄ saklama birimi (aktif cüzdana göre)
    betToRaw: (v) => betToRaw(v, normWallet(user?.active_wallet)),
    rawToBet: (v) => rawToBet(v, normWallet(user?.active_wallet)),
    // ⚠️ LİMİTLER SABİT YAZILAMAZ. Oyun sayfalarında "1 – 100.000" gömülüydü;
    // bunlar SİTE birimidir. BB Coin'de sınırlar 10.000 – 1.000.000.000
    // mili-BB olduğu için gömülü kontrol geçerli bahisleri reddederdi.
    betLimits: (walletMeta?.limits?.[wallet]) || FALLBACK_BET_LIMITS[wallet],
    walletMeta,
    refreshWalletMeta,
    switchWallet,
    switchingWallet,
  };

  return (
    <AuthContext.Provider value={value}>
      {/* ⚡ Simge degradeleri UYGULAMADA TEK KEZ tanımlanır. Kalıcı bir
          bileşende durmalı: ilk simgenin içine koysaydık o simge DOM'dan
          çıkınca diğerlerinin degradeleri kaybolurdu. */}
      <WalletIconDefs />
      {children}
    </AuthContext.Provider>
  );
};